// src/components/CommunityCounter.js
//
// "Together, we've completed 15,000+ classes."
//
// Deliberately the only community number in the app — one shared total instead
// of community badges, so it reads as a collective achievement rather than a
// leaderboard. Counts everyone who has ever trained here, including members
// who have since left.
//
// Renders nothing until the total loads (and nothing at all if the aggregate
// doc is missing or unreadable) — an empty or zeroed counter is worse than no
// counter.

import React from 'react';
import { formatCommunityTotal } from '../services/communityStats';

function CommunityCounter({ total, copy = {} }) {
    if (total === null || total === undefined) return null;
    const n = Number(total) || 0;
    if (n <= 0) return null;

    const { display } = formatCommunityTotal(n);

    return (
        <div
            style={{
                position: 'relative',
                overflow: 'hidden',
                borderRadius: 26,
                padding: '44px 30px',
                marginBottom: 20,
                textAlign: 'center',
                // FLAT charcoal, deliberately not a gradient: blending charcoal
                // toward the primary passes through brown in the middle, which is
                // what made the previous treatment look muddy.
                background: 'var(--mom-charcoal)',
                boxShadow: '0 14px 40px rgba(62,47,47,.2)',
                animation: 'fadeUp 0.5s ease both',
            }}
        >
            <div style={{
                position: 'relative', fontFamily: 'var(--mom-font-sans)', fontSize: 11,
                fontWeight: 700, letterSpacing: '0.16em', textTransform: 'uppercase',
                color: 'var(--mom-primary-light)', opacity: 0.7,
            }}>
                {copy.communityCounterLabel || "Together we've completed"}
            </div>

            <div style={{
                position: 'relative', fontFamily: 'var(--mom-font-serif)', fontStyle: 'italic',
                fontWeight: 600,
                // Clamped so a five-figure total can't overflow a narrow phone.
                fontSize: 'clamp(52px, 13vw, 88px)',
                lineHeight: 1.05, margin: '14px 0 10px',
                color: 'var(--mom-primary-light)',
            }}>
                {display}
            </div>

            <div style={{
                position: 'relative', fontFamily: 'var(--mom-font-sans)', fontSize: 15,
                color: 'var(--mom-primary-light)', opacity: 0.8,
            }}>
                {copy.communityCounterCaption || 'classes and counting'}
            </div>
        </div>
    );
}

export default CommunityCounter;
